module.exports = __webpack_public_path__ + "img/bg_gzdp.794c1e4f.svg";